import axios from "../axios";


//项目概览
export const projectOverview = (data) => {
    
    return axios({
        url: "common/query_project_statistics",
        method: "post",
        data
    })
}

//项目详情
export const projectDetails = (data) => {
    
    return axios({
        url: "common/query_project_detail",
        method: "post",
        data
    })
}

//查询项目列表
export const queryProjectList = (data) => {
    
    return axios({
        url: "common/query_project_list",
        method: "post",
        data
    })
}

//新增项目
export const addProject = (data) => {
   
    return axios({
        url: "common/add_project",
        method: "post",
        data
    })
}

//修改项目
export const modifyProject = (data) => {
   
    return axios({
        url: "common/modify_project",
        method: "post",
        data
    })
}